// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"b3f5b9bc","344":"4fcb8b12","345":"e14aaabd","382":"cb9e21bf","453":"6f27808d","512":"3911200a","579":"b54da3b6","771":"0423c53b","836":"1c326fc8","854":"8b18fbdd"}[chunkId] + ".chunk.js";
};